import { type Unit } from '../../../store/slices/unitsSlice'

export const getUnitCardActionAccess = (unit: Unit, currentUserId: unknown) => {
    const rawOwnerId = unit?.attributes?.User?.data?.id
    const ownerId = rawOwnerId == null ? Number.NaN : Number(rawOwnerId)
    const isForeignLandlordOrAgentUnit = Number.isFinite(ownerId)
        && ownerId !== Number(currentUserId)
        && (unit?.attributes?.ManagedBy === 'Landlord' || unit?.attributes?.ManagedBy === 'Agent')

    return {
        isForeignLandlordOrAgentUnit,
        canManageUnit: Number.isFinite(ownerId) && ownerId === Number(currentUserId),
    }
}
